import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { useStyles } from "./CustomBarChart.styles";
import { barcharColor, defaultTickCount } from "../../_constants";
import { useTranslation } from "react-i18next";

const CustomBarChart = ({ chart }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (chart.missing) {
    return (
      <Box display="flex" flexDirection="column" mb={3}>
        <span className={classes.title}>{chart.title}</span>
        <Box className={classes.missing}>
          <span>{t("common:customBarChart.missingData")}</span>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.root} display="flex" flexDirection="column" mb={3}>
      <span className={classes.title}>{chart.title}</span>
      <ResponsiveContainer className={classes.chartContainer}>
        <BarChart data={[chart.data]} layout="vertical">
          <CartesianGrid strokeDasharray="1 3" />
          <XAxis
            type="number"
            tickCount={defaultTickCount}
            tick={{ fontSize: 12 }}
          />
          <YAxis type="category" dataKey="name" />
          <Tooltip
            formatter={(value, name) => [
              value,
              chart.legend[Object.keys(chart.data).indexOf(name) - 1],
            ]}
          />
          <Legend
            payload={chart.legend.map((label, i) => ({
              value: label,
              type: "rect",
              id: i.toString(),
              color: barcharColor[i],
            }))}
          />
          {Object.keys(chart.data)
            .filter((key) => key !== "name")
            .map((key, i) => (
              <Bar key={i} dataKey={key} stackId="a" fill={barcharColor[i]} />
            ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

CustomBarChart.propTypes = {
  chart: PropTypes.object.isRequired,
};

export { CustomBarChart };
